
import './App.css';
import { lazy, Suspense } from 'react';
import {  BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Footer from './components/common/footer';
import Header from './components/common/header';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const Home          = lazy(() => import('./pages/home'));
const About         = lazy(() => import('./pages/about'));
const ContactUs     = lazy(() => import('./pages/ContactUs'));
const OurWork       = lazy(() => import('./pages/ourWork'));
const Services      = lazy(() => import('./pages/services'));
const Products      = lazy(() => import('./pages/products'));
const ProductDetail = lazy(() => import('./pages/productDetail'));

function App() {
  return (
    <Router>
      <Header />
      <Suspense fallback={<div style={{ minHeight: '100vh' }} />}>
        <Routes>
          <Route  exact path="/" element={<Home/>} />
          <Route  path="/about" element={<About/>} />
          <Route  path="/our-work" element={<OurWork/>} />
          <Route  path="/services" element={<Services/>} />
          <Route  path="/contact-us" element={<ContactUs/>} />
          <Route  path="/products" element={<Products/>} />
          <Route  path="/products/:slug" element={<ProductDetail/>} />
          {/* <Route path="*" element={<PageNotFound />} /> */}
        </Routes>
      </Suspense>
      <Footer/>
  </Router>
  );
}

export default App;
